import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "JavaScript Behavior Tabs"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", {
                class: "nav nav-tabs mb-4",
                id: "myTab",
                role: "tablist"
              }, [
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link active",
                    id: "home-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#home-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "home-tab-pane",
                    "aria-selected": "true"
                  }, " Home ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "profile-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#profile-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "profile-tab-pane",
                    "aria-selected": "false"
                  }, " Profile ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "contact-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#contact-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "contact-tab-pane",
                    "aria-selected": "false"
                  }, " Contact ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "disabled-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#disabled-tab-pane",
                    type: "button",
                    role: "tab",
                    "aria-controls": "disabled-tab-pane",
                    "aria-selected": "false",
                    disabled: ""
                  }, " Disabled ")
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-content",
                id: "myTabContent"
              }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "home-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "home-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Home tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "profile-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "profile-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Profile tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "contact-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "contact-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Contact tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "disabled-tab-pane",
                  role: "tabpanel",
                  "aria-labelledby": "disabled-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Disabled tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode"
                }, "\n<ul class=\"nav nav-tabs mb-4\" id=\"myTab\" role=\"tablist\">\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link active\" id=\"home-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#home-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"home-tab-pane\" aria-selected=\"true\">Home</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"profile-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#profile-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"profile-tab-pane\" aria-selected=\"false\">Profile</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"contact-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#contact-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"contact-tab-pane\" aria-selected=\"false\">Contact</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"disabled-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#disabled-tab-pane\" type=\"button\" role=\"tab\" aria-controls=\"disabled-tab-pane\" aria-selected=\"false\" disabled>Disabled</button>\n</li>\n</ul>\n<div class=\"tab-content\" id=\"myTabContent\">\n<div class=\"tab-pane fade show active\" id=\"home-tab-pane\" role=\"tabpanel\" aria-labelledby=\"home-tab\" tabindex=\"0\">\n<p>This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"profile-tab-pane\" role=\"tabpanel\" aria-labelledby=\"profile-tab\" tabindex=\"0\">\n<p>This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"contact-tab-pane\" role=\"tabpanel\" aria-labelledby=\"contact-tab\" tabindex=\"0\">\n<p>This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"disabled-tab-pane\" role=\"tabpanel\" aria-labelledby=\"disabled-tab\" tabindex=\"0\">\n<p>This is some placeholder content the Home tab's associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "JavaScript Behavior Tabs Two"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab2",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview2-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code2-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code2-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code2-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent2"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("nav", null, [
                _createElementVNode("div", {
                  class: "nav nav-tabs mb-4",
                  id: "nav-tab",
                  role: "tablist"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link active",
                    id: "nav-home-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#nav-home",
                    type: "button",
                    role: "tab",
                    "aria-controls": "nav-home",
                    "aria-selected": "true"
                  }, " Home "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "nav-profile-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#nav-profile",
                    type: "button",
                    role: "tab",
                    "aria-controls": "nav-profile",
                    "aria-selected": "false"
                  }, " Profile "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "nav-contact-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#nav-contact",
                    type: "button",
                    role: "tab",
                    "aria-controls": "nav-contact",
                    "aria-selected": "false"
                  }, " Contact "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "nav-disabled-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#nav-disabled",
                    type: "button",
                    role: "tab",
                    "aria-controls": "nav-disabled",
                    "aria-selected": "false",
                    disabled: ""
                  }, " Disabled ")
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-content",
                id: "nav-tabContent"
              }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "nav-home",
                  role: "tabpanel",
                  "aria-labelledby": "nav-home-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Home tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "nav-profile",
                  role: "tabpanel",
                  "aria-labelledby": "nav-profile-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Profile tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "nav-contact",
                  role: "tabpanel",
                  "aria-labelledby": "nav-contact-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Contact tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "nav-disabled",
                  role: "tabpanel",
                  "aria-labelledby": "nav-disabled-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Disabled tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code2-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code2-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode2"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode2"
                }, "\n<nav>\n<div class=\"nav nav-tabs mb-4\" id=\"nav-tab\" role=\"tablist\">\n<button class=\"nav-link active\" id=\"nav-home-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#nav-home\" type=\"button\" role=\"tab\" aria-controls=\"nav-home\" aria-selected=\"true\">Home</button>\n<button class=\"nav-link\" id=\"nav-profile-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#nav-profile\" type=\"button\" role=\"tab\" aria-controls=\"nav-profile\" aria-selected=\"false\">Profile</button>\n<button class=\"nav-link\" id=\"nav-contact-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#nav-contact\" type=\"button\" role=\"tab\" aria-controls=\"nav-contact\" aria-selected=\"false\">Contact</button>\n<button class=\"nav-link\" id=\"nav-disabled-tab\" data-bs-toggle=\"tab\" data-bs-target=\"#nav-disabled\" type=\"button\" role=\"tab\" aria-controls=\"nav-disabled\" aria-selected=\"false\" disabled>Disabled</button>\n</div>\n</nav>\n<div class=\"tab-content\" id=\"nav-tabContent\">\n<div class=\"tab-pane fade show active\" id=\"nav-home\" role=\"tabpanel\" aria-labelledby=\"nav-home-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Home tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"nav-profile\" role=\"tabpanel\" aria-labelledby=\"nav-profile-tab\" tabindex=\"0\">\n<p> This is some placeholder content the <strong>Profile tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"nav-contact\" role=\"tabpanel\" aria-labelledby=\"nav-contact-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Contact tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"nav-disabled\" role=\"tabpanel\" aria-labelledby=\"nav-disabled-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Disabled tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Pills Tabs"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab3",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview3-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code3-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code3-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code3-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent3"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("ul", {
                class: "nav nav-pills mb-3",
                id: "pills-tab",
                role: "tablist"
              }, [
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link active",
                    id: "pills-home-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#pills-home",
                    type: "button",
                    role: "tab",
                    "aria-controls": "pills-home",
                    "aria-selected": "true"
                  }, " Home ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "pills-profile-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#pills-profile",
                    type: "button",
                    role: "tab",
                    "aria-controls": "pills-profile",
                    "aria-selected": "false"
                  }, " Profile ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "pills-contact-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#pills-contact",
                    type: "button",
                    role: "tab",
                    "aria-controls": "pills-contact",
                    "aria-selected": "false"
                  }, " Contact ")
                ]),
                _createElementVNode("li", {
                  class: "nav-item",
                  role: "presentation"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "pills-disabled-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#pills-disabled",
                    type: "button",
                    role: "tab",
                    "aria-controls": "pills-disabled",
                    "aria-selected": "false",
                    disabled: ""
                  }, " Disabled ")
                ])
              ]),
              _createElementVNode("div", {
                class: "tab-content",
                id: "pills-tabContent"
              }, [
                _createElementVNode("div", {
                  class: "tab-pane fade show active",
                  id: "pills-home",
                  role: "tabpanel",
                  "aria-labelledby": "pills-home-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Home tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "pills-profile",
                  role: "tabpanel",
                  "aria-labelledby": "pills-profile-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Profile tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "pills-contact",
                  role: "tabpanel",
                  "aria-labelledby": "pills-contact-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Contact tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ]),
                _createElementVNode("div", {
                  class: "tab-pane fade",
                  id: "pills-disabled",
                  role: "tabpanel",
                  "aria-labelledby": "pills-disabled-tab",
                  tabindex: "0"
                }, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" This is some placeholder content the "),
                    _createElementVNode("strong", null, "Disabled tab's"),
                    _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code3-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code3-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode3"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode3"
                }, "\n<ul class=\"nav nav-pills mb-3\" id=\"pills-tab\" role=\"tablist\">\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link active\" id=\"pills-home-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#pills-home\" type=\"button\" role=\"tab\" aria-controls=\"pills-home\" aria-selected=\"true\">Home</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"pills-profile-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#pills-profile\" type=\"button\" role=\"tab\" aria-controls=\"pills-profile\" aria-selected=\"false\">Profile</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"pills-contact-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#pills-contact\" type=\"button\" role=\"tab\" aria-controls=\"pills-contact\" aria-selected=\"false\">Contact</button>\n</li>\n<li class=\"nav-item\" role=\"presentation\">\n<button class=\"nav-link\" id=\"pills-disabled-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#pills-disabled\" type=\"button\" role=\"tab\" aria-controls=\"pills-disabled\" aria-selected=\"false\" disabled>Disabled</button>\n</li>\n</ul>\n<div class=\"tab-content\" id=\"pills-tabContent\">\n<div class=\"tab-pane fade show active\" id=\"pills-home\" role=\"tabpanel\" aria-labelledby=\"pills-home-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Home tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"pills-profile\" role=\"tabpanel\" aria-labelledby=\"pills-profile-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Profile tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"pills-contact\" role=\"tabpanel\" aria-labelledby=\"pills-contact-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Contact tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"pills-disabled\" role=\"tabpanel\" aria-labelledby=\"pills-disabled-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Disabled tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1),
    _createElementVNode("div", { class: "col-lg-6" }, [
      _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
        _createElementVNode("div", { class: "card-body p-4" }, [
          _createElementVNode("h4", { class: "fs-18 mb-4" }, "Vertical Tabs"),
          _createElementVNode("ul", {
            class: "nav nav-tabs mb-4",
            id: "myTab4",
            role: "tablist"
          }, [
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link active",
                id: "preview4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#preview4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "preview4-tab-pane",
                "aria-selected": "true"
              }, " Preview ")
            ]),
            _createElementVNode("li", {
              class: "nav-item",
              role: "presentation"
            }, [
              _createElementVNode("button", {
                class: "nav-link",
                id: "code4-tab",
                "data-bs-toggle": "tab",
                "data-bs-target": "#code4-tab-pane",
                type: "button",
                role: "tab",
                "aria-controls": "code4-tab-pane",
                "aria-selected": "false"
              }, " Code ")
            ])
          ]),
          _createElementVNode("div", {
            class: "tab-content",
            id: "myTabContent4"
          }, [
            _createElementVNode("div", {
              class: "tab-pane fade show active",
              id: "preview4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "preview4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "d-flex align-items-start" }, [
                _createElementVNode("div", {
                  class: "nav flex-column nav-pills me-3",
                  id: "v-pills-tab",
                  role: "tablist",
                  "aria-orientation": "vertical"
                }, [
                  _createElementVNode("button", {
                    class: "nav-link active",
                    id: "v-pills-home-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#v-pills-home",
                    type: "button",
                    role: "tab",
                    "aria-controls": "v-pills-home",
                    "aria-selected": "true"
                  }, " Home "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "v-pills-profile-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#v-pills-profile",
                    type: "button",
                    role: "tab",
                    "aria-controls": "v-pills-profile",
                    "aria-selected": "false"
                  }, " Profile "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "v-pills-disabled-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#v-pills-disabled",
                    type: "button",
                    role: "tab",
                    "aria-controls": "v-pills-disabled",
                    "aria-selected": "false",
                    disabled: ""
                  }, " Disabled "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "v-pills-messages-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#v-pills-messages",
                    type: "button",
                    role: "tab",
                    "aria-controls": "v-pills-messages",
                    "aria-selected": "false"
                  }, " Messages "),
                  _createElementVNode("button", {
                    class: "nav-link",
                    id: "v-pills-settings-tab",
                    "data-bs-toggle": "pill",
                    "data-bs-target": "#v-pills-settings",
                    type: "button",
                    role: "tab",
                    "aria-controls": "v-pills-settings",
                    "aria-selected": "false"
                  }, " Settings ")
                ]),
                _createElementVNode("div", {
                  class: "tab-content",
                  id: "v-pills-tabContent"
                }, [
                  _createElementVNode("div", {
                    class: "tab-pane fade show active",
                    id: "v-pills-home",
                    role: "tabpanel",
                    "aria-labelledby": "v-pills-home-tab",
                    tabindex: "0"
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This is some placeholder content the "),
                      _createElementVNode("strong", null, "Home tab's"),
                      _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "tab-pane fade",
                    id: "v-pills-profile",
                    role: "tabpanel",
                    "aria-labelledby": "v-pills-profile-tab",
                    tabindex: "0"
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This is some placeholder content the "),
                      _createElementVNode("strong", null, "Profile tab's"),
                      _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "tab-pane fade",
                    id: "v-pills-disabled",
                    role: "tabpanel",
                    "aria-labelledby": "v-pills-disabled-tab",
                    tabindex: "0"
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This is some placeholder content the "),
                      _createElementVNode("strong", null, "Disabled tab's"),
                      _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "tab-pane fade",
                    id: "v-pills-messages",
                    role: "tabpanel",
                    "aria-labelledby": "v-pills-messages-tab",
                    tabindex: "0"
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This is some placeholder content the "),
                      _createElementVNode("strong", null, "Messages tab's"),
                      _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "tab-pane fade",
                    id: "v-pills-settings",
                    role: "tabpanel",
                    "aria-labelledby": "v-pills-settings-tab",
                    tabindex: "0"
                  }, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" This is some placeholder content the "),
                      _createElementVNode("strong", null, "Settings tab's"),
                      _createTextVNode(" associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation. ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: "tab-pane fade",
              id: "code4-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "code4-tab",
              tabindex: "0"
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
                "data-clipboard-target": "#basicAlertsCode4"
              }, " Copy "),
              _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
                _createTextVNode(""),
                _createElementVNode("code", {
                  class: "language-markup",
                  id: "basicAlertsCode4"
                }, "\n<div class=\"d-flex align-items-start\">\n<div class=\"nav flex-column nav-pills me-3\" id=\"v-pills-tab\" role=\"tablist\" aria-orientation=\"vertical\">\n<button class=\"nav-link active\" id=\"v-pills-home-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#v-pills-home\" type=\"button\" role=\"tab\" aria-controls=\"v-pills-home\" aria-selected=\"true\">Home</button>\n<button class=\"nav-link\" id=\"v-pills-profile-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#v-pills-profile\" type=\"button\" role=\"tab\" aria-controls=\"v-pills-profile\" aria-selected=\"false\">Profile</button>\n<button class=\"nav-link\" id=\"v-pills-disabled-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#v-pills-disabled\" type=\"button\" role=\"tab\" aria-controls=\"v-pills-disabled\" aria-selected=\"false\" disabled>Disabled</button>\n<button class=\"nav-link\" id=\"v-pills-messages-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#v-pills-messages\" type=\"button\" role=\"tab\" aria-controls=\"v-pills-messages\" aria-selected=\"false\">Messages</button>\n<button class=\"nav-link\" id=\"v-pills-settings-tab\" data-bs-toggle=\"pill\" data-bs-target=\"#v-pills-settings\" type=\"button\" role=\"tab\" aria-controls=\"v-pills-settings\" aria-selected=\"false\">Settings</button>\n</div>\n<div class=\"tab-content\" id=\"v-pills-tabContent\">\n<div class=\"tab-pane fade show active\" id=\"v-pills-home\" role=\"tabpanel\" aria-labelledby=\"v-pills-home-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Home tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"v-pills-profile\" role=\"tabpanel\" aria-labelledby=\"v-pills-profile-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Profile tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"v-pills-disabled\" role=\"tabpanel\" aria-labelledby=\"v-pills-disabled-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Disabled tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"v-pills-messages\" role=\"tabpanel\" aria-labelledby=\"v-pills-messages-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Messages tab's</strong> associated content. Clicking another tab will toggle the \tvisibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n<div class=\"tab-pane fade\" id=\"v-pills-settings\" role=\"tabpanel\" aria-labelledby=\"v-pills-settings-tab\" tabindex=\"0\">\n<p>This is some placeholder content the <strong>Settings tab's</strong> associated content. Clicking another tab will toggle the visibility of this one for the next. The tab JavaScript swaps classes to control the content visibility and styling. You can use it with tabs, pills, and any other .nav-powered navigation.</p>\n</div>\n</div>\n</div>\n"),
                _createTextVNode("\n")
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}